export default __webpack_public_path__ + "static/media/A Father's Pledge.e2709b34.jpg";